import React from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

import PropTypes from 'prop-types';

import { feedbackDuration } from '../../utils/constants';

// **********************************************************
// Valors per a type: success, info, error, warning

export default function CustomSnackbar({ handleCloseFeedback, message, show, type }) {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    handleCloseFeedback(false);
  };
  return (
    <div>
      <Snackbar open={show} autoHideDuration={feedbackDuration} onClose={handleClose}>
        <MuiAlert elevation={6} variant='filled' onClose={handleClose} severity={type}>
          {message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

// Indica i controla els props que se han de passar al component
CustomSnackbar.propTypes = {
  handleCloseFeedback: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
};
